/**
 * 阿里云oss上传
 */
const OSS = require('ali-oss');
import { STSToken } from "@/api/index"  // 需要修改成自己项目的阿里云token
function ossConfig(filename, file) {
  return new Promise((resolve, reject) => {
    STSToken().then((res) => {
      const data = res.resultData
      const ossUtil = new OSS({
        region: 'oss-cn-shenzhen',
        // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。
        accessKeyId: data.accessKeyId,
        accessKeySecret: data.accessKeySecret,
        stsToken: data.stsToken,
        secure: true,
        endpoint: data.endpoint,
        bucket: data.bucketName,
      })
      ossUtil.multipartUpload(filename, file, {}).then((res) => {
        const url = res?.res?.requestUrls?.[0]?.split("?")?.[0];
        let re = {
          url:url,
          status:true
        }
        resolve(re)
      }).catch(e => reject(e))
    })
  })
}

export {
  ossConfig
}